<template>
  <div class="v-reset-bind flex">
    <div class="v-input-box">
      <div class="v-title">
        {{ $t('bindExhibitor') }}
      </div>
      <!-- <v-input :labelName="$t('email')"></v-input>
      <v-code :labelName="$t('code')"></v-code>
      <v-input :labelName="$t('password')"></v-input>
      <v-input
        :labelName="$t('confirmPassword')"
        :placeholder="$t('newPasswordAgain')"
      ></v-input> -->
      <v-input :labelName="$t('exhibitorCode')" v-model="eCode"></v-input>
      <div class='v-login-tip margin-t-8'>{{$t("logins.loginTip2")}}</div>
      <el-button type="primary" class="v-big-btn" @click="submit">{{
        $t('confirm')
      }}</el-button>
      <div class="text-right font-size-12">
        <span class="theme-color pointer" @click="goLogin">{{
          $t('backLogin')
        }}</span>
      </div>
    </div>
    <!-- <div class="v-tip">
        <p class="font-size-14 p">{{$t('setPassPageTip[0]')}}</p>
        <p class="v-color font-size-12 p">{{$t('setPassPageTip[1]')}}</p>
    </div> -->
  </div>
</template>
<script>
import vInput from '@/components/vInput'
// import vCode from '@/components/vCodes'
import { bindExhibitorCode } from '@/api/index'
import { setToken } from '@/utils/auth'

export default {
  components: {
    vInput
    // vCode
  },
  data() {
    return {
      eCode: ''
    }
  },
  methods: {
    goLogin() {
      this.$emit('callback', { type: 'switchComponents', path: 'vLogin' })
    },
    submit() {
      if(!this.eCode){
        this.$notify.error({
          message:this.$t('Please enter your exhibitor code')
        })
        return ''
      }
      bindExhibitorCode({
        confirmationCode: this.eCode
      }).then(res => {
        if (res.data.code == 1000) {
          setToken(res.headers.authorization)
          this.$store.dispatch('BaseInfo', res.data.data)
          this.$notify({
            title: this.$t('Confirm Registration'),
            message:this.$t('You have registered, you can visit the online exhibition from June 18 to 24 by using this account'),
            type: 'success'
          })
          this.loginSuccess('ACTOR')
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-reset-bind{
    width:100%;
    .v-input-box{
        width:320px;
        // margin-right:40px;
        margin:0 auto;
    }
    .v-big-btn{
        width:100%;
        margin:24px 0 12px;
    }
    .v-color{
        color:$color-black-45;
    }
    .p{
        margin:0 0 8px;
    }
    .v-tip{
        margin-top:36px;
    }
    .v-title{
      font-size:20px;
      font-weight:500;
      color:$color-black-65;
      margin:146px 0 32px;
    }

}
</style>
